<template>
  <div>
    <v-card width="620" class="mx-auto" :loading="loading" :disabled="loading">
      <v-card-title>
        ข้อมูลจำนวนนักศึกษาระดับปริญญาโทที่มีสถานะเรียนทั้งหมด
      </v-card-title>
      <!-- <v-card-subtitle>(ตั้งแต่ปีการศึกษา 2566 เป็นต้นไป)</v-card-subtitle> -->
      <v-card-text>
        <!-- <v-autocomplete
          v-model="selected_year"
          v-bind:label="'ปีการศึกษา'"
          v-bind:items="years"
          v-bind:item-value="(item) => item"
          v-bind:item-title="(item) => item"
          outlined
        ></v-autocomplete> -->
  
        <v-btn color="green darken-3" class="white--text" @click="download(2)">
          ดาวน์โหลด<v-icon> mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
    <v-card width="620" class="mx-auto mt-4" :loading="loading" :disabled="loading">
      <v-card-title>
        ข้อมูลจำนวนนักศึกษาระดับปริญญาเอกที่มีสถานะเรียนทั้งหมด
      </v-card-title>
      <v-card-text>
        <v-btn color="green darken-3" class="white--text" @click="download(3)">
          ดาวน์โหลด<v-icon> mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>
  
  <script>
  import ReportProvider from "@/services/report.provider.js";
  const ReportService = new ReportProvider();
  import { studentStudyExcel } from "./generate.js";
  
  export default {
    name: "ReportXStudent",
  
    data: () => ({
      loading: false,
    //   years: [],
      selected_year: null,
      selected_month: null,
    }),
  
    methods: {
      studentStudyExcel,
  
    //   async getYears() {
    //     const data = new Date().getFullYear() + 543;
    //     this.years = [data, data - 1, data - 2];
    //   },
  
      async download(level) {
        this.loading = true;
        const data = await ReportService.getReportXStudentStudy(
          this.selected_year, this.selected_month, level
        ).catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });
        var leveltxt = '';
        if (level == 2) {
          leveltxt = 'ปริญญาโท';
        } else if (level == 3) {
          leveltxt = 'ปริญญาเอก';
        }
        studentStudyExcel(data, leveltxt);
        this.loading = false;
      },
    },
  
    // created() {
    //   this.getYears();
    // },
  };
  </script>
  